import { useMemo } from 'preact/hooks';

function hashStringToNumber(seed: string): number {
    let hash = 0;
    for (let i = 0; i < seed.length; i++) {
        const char = seed.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}

export function useSeedRandom(seed: string, module: number): number {
    const seedRandom = useMemo(() => {
        const numericSeed = hashStringToNumber(seed);
        return Math.abs(numericSeed % module);
    }, [seed, module]);
    return seedRandom;
}
